import axios from 'axios';

const baseUrl = '/web';

axios.defaults.baseURL = baseUrl;

function successResp(resp, func) {
  const respData = resp.data;

  if (respData.code === 200) {
    return func && func(respData.data || respData);
  } else {
    errorResp(resp);
  }
}

function errorResp(error) {
  const errorData = error.data;
  console.error(errorData);
}

export {
  axios as Request,
  successResp,
  errorResp,
};
